export const EVENTS_ROUTES = Object.freeze({
  publicoffice: {
    network: {
      index: Routes.private_publicoffice_dynamic_components_events_path,
      show: Routes.private_publicoffice_dynamic_components_event_path,
    },
    topic: {
      index: Routes.private_publicoffice_dynamic_components_topic_events_path,
      show: Routes.private_publicoffice_dynamic_components_topic_event_path,
    },
  },
  frontoffice: {
    network: {
      index: Routes.private_frontoffice_dynamic_components_events_path,
      show: Routes.private_frontoffice_dynamic_components_event_path,
    },
    topic: {
      index: Routes.private_frontoffice_dynamic_components_topic_events_path,
      show: Routes.private_frontoffice_dynamic_components_topic_event_path,
    },
  },
});

export const NEWS_ROUTES = Object.freeze({
  publicoffice: {
    network: {
      index: Routes.private_publicoffice_dynamic_components_news_index_path,
      show: Routes.private_publicoffice_dynamic_components_news_path,
    },
    topic: {
      index:
        Routes.private_publicoffice_dynamic_components_topic_news_index_path,
      show: Routes.private_publicoffice_dynamic_components_topic_news_path,
    },
  },
  frontoffice: {
    network: {
      index: Routes.private_frontoffice_dynamic_components_news_index_path,
      show: Routes.private_frontoffice_dynamic_components_news_path,
    },
    topic: {
      index:
        Routes.private_frontoffice_dynamic_components_topic_news_index_path,
      show: Routes.private_frontoffice_dynamic_components_topic_news_path,
    },
  },
});

export const POSTS_ROUTES = Object.freeze({
  frontoffice: {
    network: {
      index: Routes.private_frontoffice_dynamic_components_posts_path,
    },
    topic: {
      index: Routes.private_frontoffice_dynamic_components_topic_posts_path,
    },
  },
});
